export const colors = {
  transparent: 'transparent',
  white: '#ffffff',
  gray: {
    lightest: '#fdfcfe',
    light: '#F0F4F8',
    medium: '#B6B6B6',
    dark: '#4A4A4A',
  },
  black: '#1D252B', //spremenjeno
  blue: {
    lightest: '#D4D7E7',
    light: '#41A9D9', //spremenjeno
    medium: '#2562BA', //spremenjeno
    dark: '#0F2A43',
  },
  green: {
    light: '#F8FAF9',
    medium: '#D0E1D5',
    dark: '#5CEDBD', //spremenjeno
    darkest: '#43A097', //dodano
  },
  red: {
    lightest: '#fff0f2',
    light: '#FF9B9A',
    medium: '#912d2c',
  },
  orange: '#FFF9F2',
  purple: {
    light: '#F0F2FB',
    medium: '#E3E5F2',
    dark: '#8E1EBF', //spremenjeno
    darkest: '#22043B', //dodano
  },
  yellow: {
    light: '#fff0a8',
    dark: '#F4B87F', //spremenjeno
    darkest: '#8a6d3b',
  },
};

export const details = {
  borderRadius: '3px',
};

export const rainbowColors = [
  '#43A097', //green
  '#43A097',
  //'#43A097', //dark green - dodano
  //'#fdccd3', // pink
  //'#fca09a', // red
  //'#ffcc9e', // yellow
  //'#98ddad', // green
  //'#81d7ec', // blue
  //'#91C1ED', // blurple
  //'#a0aaed', // purple
];

export const rainbowBGColors = [
  '#fdccd3', // pink
  '#FED4D1', // red
  '#fcead9', // yellow-orange
  '#dcf0df', // green
  '#d3edf6', // blue
  '#baccf2', // blurple
  '#a0aaed', // purple
];

export const rainbowLightColors = [
  '#fef2f4', // pink
  '#fdf8f7', // red
  '#FFF2E6', // yellow-orange
  '#e5f6ea', // green
  '#dff5fa', // blue
  '#E3EFFA', // blurple
  '#e7e9fa', // purple
];

export const rainbowBGColors2 = [
  '#dcf0df', // green
  '#d3edf6', // blue
  '#baccf2', // blurple
  '#a0aaed', // purple
  '#baccf2', // blurple
  '#d3edf6', // blue
  '#dcf0df', // green
];

export const rainbowLightColors2 = [
  '#e5f6ea', // green
  '#dff5fa', // blue
  '#E3EFFA', // blurple
  '#e7e9fa', // purple
  '#E3EFFA', // blurple
  '#dff5fa', // blue
  '#e5f6ea', // green
];

export const rainbow = rainbowColors.join(', ');
export const rainbowLight = rainbowLightColors.join(', ');

export const screenSizes = {
  smaller: '420px',
  small: '576px',
  medium: '768px',
  large: '992px',
  larger: '1200px',
  largest: '1440px',
  huge: '1820px',
};

export const styledComponentsTheme = {
  ...colors,
  screenSizes,
  ...details,
  rainbow,
  rainbowLight,
  rainbowLightColors,
};
